<template>
    <div v-if="showBanner" class="floating-container" :style="customStyle">
        <div class="floating-banner--container">
            <div class="message-container">
                <p v-text="bannerMessage"></p>
                <p class="close-btn" @click="toggle()">x</p>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'FloatingBanner',
    props: {
        customStyle: {
            type: Object,
        },
    },
    computed: {
        ...mapGetters({
            showBanner: 'account/showFloatingBanner',
            bannerMessage: 'account/getBannerMessage',
        }),
    },

    methods: {
        toggle() {
            return this.$store.commit('account/setShowFloatingBanner', false);
        },
    },
};
</script>

<style lang="scss" scoped>
    .floating-container {
        position: absolute;
        top: 24px;
        width: 100%;
        display: flex;
        justify-content: center;
        z-index: 9999;
    }

    .floating-banner {
        &--container {
            background: #262323;
            color: #FFFFFF;
            max-width: 400px;
            padding: 0px 24px;
            height: 72px;
        }
    }

    .message-container {
        display: flex;
        height: 100%;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }

    .close-btn {
        margin-left: 24px;
        cursor: pointer;
    }

    @media (min-width: 740px) {
        .floating-banner {
            &--container {
                border-radius: 65px;
                max-width: 612px;
            }
        }
    }
</style>
